type AllocationInputs = {
  effectiveBudget: number
  ineffectiveBudget: number
  unallocatedBudget: number
}

type AllocationChecks = {
  isFullyAllocated: boolean
  neverAllocatedAmount: number
  hasUnderDelivery: boolean
  underDeliveredAmount: number
  showAllocationWarning: boolean
}

export const getAllocationChecks = ({
  effectiveBudget,
  ineffectiveBudget,
  unallocatedBudget,
}: AllocationInputs): AllocationChecks => {
  const isFullyAllocated = unallocatedBudget <= 0

  // the amount of budget that was never allocated, min 0
  const neverAllocatedAmount =
    Math.max(0, unallocatedBudget - ineffectiveBudget) < 1 ? 0 : Math.max(0, unallocatedBudget - ineffectiveBudget)

  // the amount of budget that we were not able to deliver, it cannot be greater than the unallocated budget
  const underDeliveredAmount = Math.min(Math.max(0, ineffectiveBudget), unallocatedBudget)

  const hasUnderDelivery = underDeliveredAmount > 0

  const showAllocationWarning = !isFullyAllocated && (effectiveBudget > 0 || ineffectiveBudget > 0)

  return {
    isFullyAllocated,
    neverAllocatedAmount,
    hasUnderDelivery,
    underDeliveredAmount,
    showAllocationWarning,
  }
}
